import { jsx } from "react/jsx-runtime";
import React from "react";
import ToolbarItem from "./ToolbarItem";
import CollaborationBadge from "../Collab/CollaborationBadge";
import { connectToEditor } from "../withEditorProps";
export default connectToEditor(
  ({
    collabIsConnected = false,
    collabCollaborators = [],
    collabRoomName = ""
  }) => {
    return {
      collabIsConnected,
      collabCollaborators,
      collabRoomName
    };
  }
)(({
  collabIsConnected,
  collabCollaborators,
  collabRoomName,
  toolbarItemProps
}) => {
  return /* @__PURE__ */ jsx("div", { style: { display: "inline-flex", alignItems: "center" }, children: /* @__PURE__ */ jsx(
    CollaborationBadge,
    {
      isConnected: collabIsConnected,
      collaborators: collabCollaborators,
      roomName: collabRoomName
    }
  ) });
});
